import { defineMessages } from "react-intl";
export var messages = defineMessages({
  sideNavTitle: {
    id: "jutro-floorplan.SideNavigation.title",
    defaultMessage: "Side Navigation"
  }
});